// extracted by mini-css-extract-plugin
module.exports = {"BuyOptions":"BuyOptions_BuyOptions__1yl6t","BtnGroup":"BuyOptions_BtnGroup__3zhAa"};